var collectionBanner = document.querySelector(
  ".shopify-section--collection-banner",
);
var collectionSlideshow = document.querySelector(".shopify-section--slideshow");
var collectionImageWithTextOverlay = document.querySelector(
  ".shopify-section--image-with-text-overlay",
);
if (collectionBanner || collectionSlideshow || collectionImageWithTextOverlay) {
  document.querySelector("body").classList.add("caremare-logo");

  window.addEventListener("scroll", () => {
    if (window.scrollY > 0) {
      document.querySelector("body").classList.remove("caremare-logo");
    } else {
      document.querySelector("body").classList.add("caremare-logo");
    }
  });
}

if (!window.customElements.get("product-sticky-bar")) {
  class ProductStickyBar extends HTMLElement {
    #observer = new IntersectionObserver(this.#onFooterVisibilityChange.bind(this));
    #footerElement;

    connectedCallback() {
      this.classList.add("is-visible");
      this.#footerElement = document.querySelector(".shopify-section--footer");
      if (this.#footerElement) {
        this.#observer.observe(this.#footerElement);
      }
    }

    disconnectedCallback() {
      this.#observer.disconnect();
    }

    #onFooterVisibilityChange(entries) {
      const footerEntry = entries[0];
      this.classList.toggle("is-visible", !footerEntry.isIntersecting);
    }
  }

  window.customElements.define("product-sticky-bar", ProductStickyBar);
}